/*
 * returns an array containing all values present in 'arrayOne'
 * as well as in 'arrayTwo'
 *
 * intersection([ 2, 3, 5, 7, 11 ], [ 1, 2, 3, 4, 5 ]) -> [ 2, 3, 5 ]
 */

module.exports = function intersection (arrayOne, arrayTwo) {
  return arrayOne.filter(
    value => arrayTwo.includes(value)
  )
}
